import React from 'react';
import PropTypes from 'prop-types';

export default function TaggedUrlLine({ segments }) {
  return (
    <div className="tagged-url-preview__url">
      {segments.map((segment, index) => {
        const key = `${segment.type}-${index}`;
        if (segment.type === 'url-placeholder') {
          return (
            <span key={key} className="tagged-url-preview__placeholder tagged-url-preview__placeholder--required">
              {`{${segment.label}}`}
            </span>
          );
        }
        if (segment.type !== 'param' && segment.type !== 'placeholder') {
          return <span key={key}>{segment.text}</span>;
        }
        return (
          <span key={key}>
            <span className="tagged-url-preview__key">{`${segment.separator}${segment.key}=`}</span>
            {segment.type === 'param' ? (
              <span className="tagged-url-preview__value">{segment.value}</span>
            ) : (
              <span className={`tagged-url-preview__placeholder tagged-url-preview__placeholder--${segment.reason}`}>
                {`{${segment.label}}`}
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}

TaggedUrlLine.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string.isRequired })).isRequired,
};
